export default {"src":"/org/_next/static/media/arrow-right.01360026.svg","height":10,"width":11,"blurWidth":0,"blurHeight":0};